import { mapGetters } from 'vuex'
import { generateMetaInfo } from '../../common'

import Error from 'views/Error'
import Title from 'components/Title'
import FlexContent from 'components/FlexContent'
import HeroImage from 'components/HeroImage'

export default {
  name: 'HomeView',
  computed: {
    ...mapGetters(['loading', 'getPageBySlug', 'options']),
    page () {
      return this.getPageBySlug('home')
    },
    pageTitle () {
      return this.page.page_title_override ? this.page.page_title_override : this.page.title.rendered
    }
  },
  metaInfo () {
    const page = this.page
    return page ? generateMetaInfo(this.options, this.page, { isHome: true }) : {}
  },
  mounted () {
    this.setCurrentPage(this.page)
  },
  created () {
    this.setCurrentPage(this.page)
  },
  watch: {
    '$route': function () {
      this.setCurrentPage(this.page)
    },
    loading: function () {
      this.setCurrentPage(this.page)
    }
  },
  methods: {
    setCurrentPage (page) {
      this.$store.dispatch('setCurrentPage', page)
    },
    renderError () {
      // this.log('error')
      return <Error />
    },
    renderPage () {
      // this.log(this.page)
      return (
        <div class='page'>
          {this.page.hero_image
            ? (<HeroImage imageUrl={this.page.hero_image.sizes.friwi_huge} />)
            : null
          }
          {this.pageTitle
            ? (<Title level={1} id={this.pageTitle}>{this.pageTitle}</Title>)
            : null
          }
          {this.page.c_flex_content && this.page.c_flex_content.length
            ? (<FlexContent componentData={this.page.c_flex_content} />)
            : null
          }
        </div>
      )
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   // console.log(to)
  //   next()
  // },
  // beforeRouteUpdate (to, from, next) {
  //   // console.log(to)
  //   next()
  // },
  render (h) {
    const { loading, page } = this
    // this.log('page')
    return (
      loading ? 'Loading…' : (page
        ? this.renderPage()
        : this.renderError()
      )
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/Home/index.js